import React, { useEffect } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import Checkbox from "@material-ui/core/Checkbox";
import { Button, Row, Col, Form, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loader from "react-loader-spinner";
import * as XLSX from "xlsx";
import axios from "axios";
import AADService from "../../auth/authFunctions";
import { IoMdDownload } from "react-icons/io";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#2c2a29",
    color: theme.palette.common.white,
  },
}))(TableCell);
const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: "#f4f4f4",
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "60vh",
    minHeight: "60vh",
  },
});

export default function Proveedores(props) {
  const serviceAAD = new AADService();
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selected, setSelected] = React.useState([]);
  const [ButtonEdit, SetButtonEdit] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [dataBusqueda, setDataBusqueda] = React.useState([]);
  const [loadingData, setLoadingData] = React.useState(false);
  const [buscando, setBuscando] = React.useState(null);
  const [data_upload, setDataUpload] = React.useState(null);
  const [estadoPost, setEstadoPost] = React.useState({
    alerta: { id: 0, data: null },
  });
  const [cargaC, setCargaC] = React.useState(false);
  const [cargaP, setCargaP] = React.useState(false);


  useEffect(() => {
    const fetchdata = async () => {
      setLoadingData(true);
      const result = await fetch(
        process.env.REACT_APP_API_URL + "/maestros_ro/proveedor/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
        }
      );
      let data = await result.json();
      setData(data);
      setDataBusqueda(data);
      setLoadingData(false);
    };
    fetchdata();
    setLoadingData(false);
  }, []);

  function AlertDismissibleExample({ alerta }) {
    switch (alerta.id) {
      case 1:
        return <Alert variant="success">Editado con éxito!</Alert>;
  
      case 2:
        return <Alert variant="danger">{alerta.response}</Alert>;
  
      case 3:
        return <Alert variant="success">Creado con éxito!</Alert>;
  
      case 4:
        return (
          <Alert variant="warning">
            Error del servidor
          </Alert>
        );
      default:
        return <p></p>;
    }
  }
  /* Funciones para paginación */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  async function fileFromURL(url) {
    let urlConsulta = url;
    axios({
      url: urlConsulta,
      method: "GET",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + serviceAAD.getToken(),
      },
    }).then((response) => {
      let name = urlConsulta.split("/").pop();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      // setCarga(false);
      // setDescarga(true);
    });
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  /* Fin de funciones para paginación */
  /* Función para seleccionar un Área para Editar */
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat([], name);
      SetButtonEdit(true);
    } else {
      SetButtonEdit(false);
    }
    setSelected(newSelected);
  };
  const editar = (event) => {
    localStorage.setItem("idProveedor", selected[0]);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  async function buscar(e) {
    e.persist();
    //await setBuscando(e.target.value);
    var search = data.filter((item) => {
      if (
        String(item.ID_SAP).toLowerCase().includes(e.target.value.toLowerCase()) ||
        String(item.NIT).includes(e.target.value.toLowerCase()) ||
        item.Nombre_Proveedor.toLowerCase().includes(
          e.target.value.toLowerCase()
        )
      ) {
        return item;
      }
    });
    await setBuscando(e.target.value);
    await setDataBusqueda(search);
  }

  const subirArchivo = (files) => {
    const file = files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });

      // Crear objeto para guardar las hojas
      const jsonData = {};

      // Recorrer todas las hojas del libro
      workbook.SheetNames.forEach((sheetName) => {
        const worksheet = workbook.Sheets[sheetName];
        jsonData[sheetName] = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      });

      setDataUpload(jsonData);
      console.log("JSON con todas las hojas:", jsonData);
    };

    reader.readAsBinaryString(file);
  };

  const cargarProcesos = async (metodo) => {
    if (!data_upload) {
      alert("Por favor, suba un archivo primero.");
      return;
    }

    setLoadingData(true);

    const hoja_contratos = data_upload.Contratos;
    const hoja_proveedores = data_upload.Proveedores;

    if (!hoja_contratos && !hoja_proveedores) {
      alert("Las hojas 'Contratos' o 'Proveedores' no están presentes en el archivo.");
      setLoadingData(false);
      return;
    }

    try {
      if (hoja_contratos) {
        const configContratos = {
          method: metodo,
          url: `${process.env.REACT_APP_API_URL}/contrato_post`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
          data: hoja_contratos,
        };

        const responseContratos = await axios(configContratos);
        if (metodo == "put") {
          setEstadoPost({ id: 1, response: responseContratos.data });
          setCargaC(false);
        } else {
          setEstadoPost({ id: 3, response: responseContratos.data });
          setCargaC(false);
        }
        // alert("Contratos cargados correctamente.");
      }

      if (hoja_proveedores) {
        const configProveedores = {
          method: metodo,
          url: `${process.env.REACT_APP_API_URL}/proveedor_post`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
          data: hoja_proveedores,
        };

        const responseProveedores = await axios(configProveedores);
        if (metodo == "put") {
          setEstadoPost({ id: 1, response: responseProveedores.data });
          setCargaP(false);
        } else {
          setEstadoPost({ id: 3, response: responseProveedores.data });
          setCargaP(false);
        }
      }
    } catch (error) {
      if (error.response) {
        // console.error("❌ Error de API (status):", error.response.status);
        // console.error("❌ Detalles:", error.response.data);
        setEstadoPost({ id: 2, response: error.response.data.error });
        if (hoja_contratos) {
          setCargaC(true);
        }
        if (hoja_proveedores) {
          setCargaP(true);
        }
        // alert(`Error ${error.response.status}: ${JSON.stringify(error.response.data)}`);
      } else if (error.request) {
        setEstadoPost({ id: 4, response: "No hubo respuesta del servidor." });
        if (hoja_contratos) {
          setCargaC(true);
        }
        if (hoja_proveedores) {
          setCargaP(true);
        }
        // console.error("❌ No hubo respuesta del servidor:", error.request);
        // alert("No hubo respuesta del servidor.");
      } else {
        setEstadoPost({ id: 4, response: "No hubo respuesta del servidor." });
        if (hoja_contratos) {
          setCargaC(true);
        }
        if (hoja_proveedores) {
          setCargaP(true);
        }
        // console.error("❌ Error al configurar la solicitud:", error.message);
        // alert("Error inesperado al realizar la solicitud.");
      }
    } finally {
      setLoadingData(false);
    }
  };
  return (
    <>
    <AlertDismissibleExample alerta={estadoPost} />
      <Row className="mb-3" style={{
        display:
          (props.permisos.crear)
            ? "flex"
            : "none",
      }}>
        <Col sm={3} xs={12}>
          <label className="label forn-label">Descargar formato</label>
        </Col>
        <Col sm={3} xs={12}>
          <label className="label forn-label">Seleccione archivo</label>
        </Col>
        <Col sm={6} xs={12}>
          <input
            type="file"
            name="files"
            accept=".xlsx,.csv"
            onChange={(e) => subirArchivo(e.target.files)}
          ></input>
        </Col>
      </Row>
      <Row className="mb-3" style={{
        display:
          (props.permisos.crear)
            ? "flex"
            : "none",
      }} >
        <Col sm={3} xs={12}>
          <button
            type="button"
            className="btn botonPositivo"
            onClick={() =>
              fileFromURL(
                process.env.REACT_APP_API_URL + "/download/cargadores/cargador_proveedores.xlsx"
              )
            }
          >
            Descargar formato &nbsp;
            <IoMdDownload />
          </button>
        </Col>
        <Col sm={3} xs={12}>
          <button
            type="button"
            className="btn botonPositivo"
            onClick={() => cargarProcesos("post")}
          >
            Cargar elementos masivamente
          </button>
        </Col>
        <Col sm={3} xs={12}>
          <button
            type="button"
            className="btn botonGeneral"
            onClick={() => cargarProcesos("put")}
          >
            Actualizar elementos masivamente
          </button>
        </Col>
        <Col sm={3} xs={12}>
          <Button
            id="buttonEfectos"
            type="button"
            className="btn botonPositivo"
            disabled={!cargaC}
            onClick={() => fileFromURL(process.env.REACT_APP_API_URL + "/download/eventos/Logs_Contratos.xlsx")}
          >
            Descargar Informe de cargue Contratos &nbsp;
            <IoMdDownload />
          </Button>
        </Col>
        <Col sm={3} xs={12}>
          <Button
            id="buttonEfectos"
            type="button"
            className="btn botonPositivo"
            disabled={!cargaP}
            onClick={() => fileFromURL(process.env.REACT_APP_API_URL + "/download/eventos/Logs_Proveedor.xlsx")}
          >
            Descargar Informe de cargue Proveedores &nbsp;
            <IoMdDownload />
          </Button>
        </Col>

      </Row>
      <Row
        style={{ marginTop: "1%", marginBottom: "0.5%" }}
        className="mb-3 mt-3"
      >
        <Col sm={4} xs={12}>
          <Form>
            <Form.Control
              id="buscarProveedor"
              value={buscando}
              onChange={(e) => buscar(e)}
              type="text"
              placeholder="Buscar"
            />
          </Form>
        </Col>
        <Col sm={4} xs={6}>
          <Link to="EditarProveedor">
            <Button
            id={"ver/editar-proveedor"}
              className="botonNegativo"
              style={{
                display:
                  ButtonEdit && (props.permisos.editar || props.permisos.ver)
                    ? "inline"
                    : "none",
              }}
              onClick={(event) => editar(event)}
            >
              Ver / Editar
            </Button>
          </Link>
        </Col>
        <Col sm={4} xs={6}>
          {props.permisos.crear ? (
            <Link to="NuevoProveedor">
              <Button className="botonPositivo">Nuevo</Button>
            </Link>
          ) : null}
        </Col>
      </Row>

      {loadingData ? (
        <Row className="mb-3 mt-5">
          <Col>
            <Loader
              type="Oval"
              color="#FFBF00"
              style={{ textAlign: "center", position: "static" }}
            />
          </Col>
        </Row>
      ) : (
        <Paper className={classes.root}>
          <TableContainer component={Paper} className={classes.container}>
            <Table className={"text"} stickyHeader aria-label="sticky table">
              {/* Inicio de encabezado */}
              <TableHead className="titulo">
                <TableRow>
                  <StyledTableCell padding="checkbox"></StyledTableCell>
                  <StyledTableCell>ID SAP</StyledTableCell>
                  <StyledTableCell>NIT</StyledTableCell>
                  <StyledTableCell align="left">Nombre</StyledTableCell>
                  <StyledTableCell>Compania</StyledTableCell>
                  <StyledTableCell>Estado</StyledTableCell>
                </TableRow>
              </TableHead>
              {/* Fin de encabezado */}
              {/* Inicio de cuerpo de la tabla */}
              <TableBody>
                {dataBusqueda
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.ID_SAP);
                    return (
                      <StyledTableRow
                        key={row.ID_SAP}
                        hover
                        onClick={(event) => handleClick(event, row.ID_SAP)}
                        selected={isItemSelected}
                        role="checkbox"
                        tabIndex={-1}
                      >
                        <StyledTableCell component="th" scope="row">
                          <Checkbox checked={isItemSelected} id="checkboxProveedor" />
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.ID_SAP}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.NIT}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.Nombre_Proveedor}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.compania}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                        {row.estado === '0' ? 'Inactivo' : 'Activo'}
                      </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
              </TableBody>
              {/* Fin de cuerpo de la tabla */}
            </Table>
          </TableContainer>
          {/* Inicio de paginación */}
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          {/* Fin de paginación */}
        </Paper>
      )}
    </>
  );
}
